import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { process } from '../data/site';
export function ProcessSection() {
  return <section id="process" className="bg-ivory-200 py-24 lg:py-32" data-id="element-127" data-mp="u1xk2zlhfiyc">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10" data-id="element-128" data-mp="u25v0ly1oe6w">
        <SectionHeading eyebrow="The Process" align="center" title={<>
              Measured twice. <span className="italic text-brass" data-id="element-130" data-mp="1mptchs40qopb">Charmed once.</span>
            </>} description="A short, unhurried sequence that removes hardware from your punch list entirely." data-id="element-129" data-mp="p3mb0r30hch6" />

        <ol className="mt-16 grid gap-px overflow-hidden border border-ivory-300 bg-ivory-300 md:grid-cols-2 lg:grid-cols-4" data-id="element-131" data-mp="1cyoyovq2x9w2">
          {process.map((item, index) => <motion.li key={item.step} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="bg-ivory p-8 lg:p-10" data-id="element-132" data-mp="25huirfj4hh8r" data-mpi={index}>
              <span className="font-display text-5xl text-brass/40" data-id="element-133" data-mp="2b3k23bln10nq">{item.step}</span>
              <h3 className="mt-6 font-display text-2xl text-ink" data-id="element-134" data-mp="1wcb7sp6sir49">{item.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground" data-id="element-135" data-mp="21aczfyia7yrc">{item.body}</p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}